module.exports = __webpack_public_path__ + "static/assets/10ce7deabcbf4cccb17cca2621b94345.png";